/* eslint-disable deprecation/deprecation */
import { TextField, TextFieldProps } from '@mui/material';
import { NoddiIcon } from 'noddi-ui-common';
import { forwardRef } from 'react';
import { NoddiToolTip } from '../../../molecules/NoddiToolTip';

/**
 * @deprecated
 */
const NoddiTextInput = forwardRef<HTMLInputElement, TextFieldProps & { tooltip?: string }>((props, ref) => {
  const { label, name, variant = 'outlined', tooltip } = props;

  const labelIdentifier = `${name}_label`;

  return (
    <div>
      <label id={labelIdentifier} htmlFor={name} className='flex items-center gap-2'>
        {label}
        {tooltip && (
          <NoddiToolTip content={tooltip} position='top'>
            <NoddiIcon name='Info' size='sizeForChip' />
          </NoddiToolTip>
        )}
      </label>
      <TextField
        data-testid='noddi-text-input'
        fullWidth
        variant={variant}
        {...props}
        inputProps={{
          ...props.inputProps,
          'aria-labelledby': labelIdentifier
        }}
        inputRef={ref}
        label={undefined}
        onWheel={(event) => {
          const target = event.target as HTMLInputElement;
          target.blur();
        }}
      />
    </div>
  );
});

NoddiTextInput.displayName = 'NoddiTextInput';

export { NoddiTextInput };
